export enum PlayerType {
  NewWindow,
  IFrame,
  IFramePlayer,
}
